import React from "react";
import MuiToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { styled } from "@mui/material/styles";

interface ViewSelectorProps {
  exclusive?: boolean;
  onChange: (event: any, newSelected: any) => void;
  value: any;
  views: string[];
}

const ToggleButton = styled(MuiToggleButton)(() => ({
  "&.Mui-selected, &.Mui-selected:hover": {
    color: "white",
    backgroundColor: "black",
  },
}));

const ViewSelector: React.FC<ViewSelectorProps> = ({
  exclusive,
  onChange,
  value,
  views,
}) => {
  return (
    <ToggleButtonGroup
      value={value}
      onChange={onChange}
      sx={{ margin: 0, marginBottom: "20px" }}
      exclusive={!!exclusive}
    >
      {views.map((view, index) => (
        <ToggleButton
          key={index}
          value={view.toLowerCase()}
          sx={{
            borderBottomLeftRadius: index === 0 ? "50px" : 0,
            borderBottomRightRadius: index === views.length - 1 ? "50px" : 0,
            borderTopLeftRadius: index === 0 ? "50px" : 0,
            borderTopRightRadius: index === views.length - 1 ? "50px" : 0,
            fontFamily: "Lato",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "normal",
            color: "black",
            backgroundColor: "white",
            paddingLeft: "150px",
            paddingRight: "150px",
          }}
        >
          {view}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ViewSelector;
